var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferNotValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50016 17.4163C5.12791 17.4163 1.5835 13.8719 1.5835 9.49967C1.5835 5.12742 5.12791 1.58301 9.50016 1.58301C13.8724 1.58301 17.4168 5.12742 17.4168 9.49967C17.4168 13.8719 13.8724 17.4163 9.50016 17.4163ZM8.7085 11.8747V13.458H10.2918V11.8747H8.7085ZM8.7085 5.54134V10.2913H10.2918V5.54134H8.7085Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferNotValid);
export default __webpack_public_path__ + "static/media/offerNotValid.273898c11aa28ca0d8a2791997c70c7f.svg";
export { ForwardRef as ReactComponent };